export class TempFormHelper {
  static create(url, method, func = null, element = null) {
    const form = document.createElement("form")

    form.action = url
    form.method = "post"

    if (method) {
      if (["post", "get"].includes(method)) {
        form.method = method
      } else {
        TempFormHelper.addHiddenInput(form, "_method", method)
      }

      if (method == "delete") {
        form.setAttribute("data-turbo-method", "delete")
        form.setAttribute("data-turbo-frame", "_top")
      }
    }

    if (document.querySelector("meta[name='csrf-token']")) {
      TempFormHelper.addHiddenInput(form, "authenticity_token", document.querySelector("meta[name='csrf-token']").content)
    }

    if (func) {
      func(form)
    }

    if (element) {
      element.appendChild(form)
    } else {
      document.body.appendChild(form)
    }

    return form
  }

  static createFromEvent(event, func = null, element = null) {
    const url = event.detail.url !== undefined ? event.detail.url : event.params.url
    const method = event.detail.method !== undefined ? event.detail.method : event.params.method

    return TempFormHelper.create(url, method, func, element)
  }

  static addHiddenInput(form, name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value

    form.appendChild(input)
  }
}
